import React from 'react'
import { BogoPromotionNonAppliedErrorMessage } from '@mc/bogo'
import { isBogoPromotionNonAppliedError } from '@mc/bogo-utils'
import { Conditional, ShowIf } from '@mc/conditional-rendering'
import { usePromotion } from '@mc/promo-utils'
import { isPromotionError } from '../../../lib/helpers'
import { PromotionErrorText } from '../..'

export const PromotionAppliedOnErrorText = ({ error }: { error: string }) => {
  const { isPromotionOn } = usePromotion()

  return (
    <Conditional>
      <ShowIf condition={isPromotionOn && isPromotionError(error)}>
        <PromotionErrorText />
      </ShowIf>
      <ShowIf condition={isBogoPromotionNonAppliedError(error)}>
        <BogoPromotionNonAppliedErrorMessage />
      </ShowIf>
      <ShowIf isDefault>
        <p>{error}</p>
      </ShowIf>
    </Conditional>
  )
}
